import {useQuery} from "@apollo/client";
import React from "react";
import {FieldErrors, FormProvider, useForm} from "react-hook-form";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import FormErrorAlerts from "@/components/form/FormErrorAlerts.tsx";
import {ServiceField} from "@/lib/constants/service.ts";
import {GQL_GET_SERVICE_DEFINITIONS} from "@/lib/queries/checks.ts";
import {ServiceDefinition, ServiceFieldDefinition} from "@/lib/types/checks.ts";
import {ServerErrors} from "@/lib/types/common.ts";
import {EditCheckUpgradeCheckerVersionFormValues} from "@/pages/checks/list/actions/bulkUpgradeCheckerVersion/BulkUpgradeCheckerVersionModal.tsx";

export interface BulkUpgradeCheckerVersionFormProps {
  formId: string;
  onSubmit: (data: EditCheckUpgradeCheckerVersionFormValues) => void;
  onError?: (errors: FieldErrors<EditCheckUpgradeCheckerVersionFormValues>, event?: React.BaseSyntheticEvent) => void;
  serverErrors?: ServerErrors;
}

export const BulkUpgradeCheckerVersionForm = ({
  formId,
  onSubmit,
  onError,
  serverErrors,
}: BulkUpgradeCheckerVersionFormProps) => {
  const {data} = useQuery<{serviceDefinitions: ServiceDefinition[]}>(GQL_GET_SERVICE_DEFINITIONS);

  let mspVersionField: ServiceFieldDefinition | undefined;

  data?.serviceDefinitions.forEach((serviceDefinition) => {
    serviceDefinition.fields.forEach((field) => {
      if (field.field === "msp_version" && !mspVersionField) {
        mspVersionField = field;
      }
    });
  });

  const methods = useForm<EditCheckUpgradeCheckerVersionFormValues>({
    defaultValues: {
      msp_version: undefined,
    },
  });
  return (
    <FormProvider {...methods}>
      <form
        id={formId}
        onSubmit={(e) => {
          methods.handleSubmit(onSubmit, onError)(e);
        }}
      >
        {serverErrors?.schedule_entries && <FormErrorAlerts errors={serverErrors?.schedule_entries} />}
        <div className="row mb-4">
          <div className="col fst-italic">
            Note: The current checker version on selected checks will be replaced with the new setting chosen below.
          </div>
        </div>
        <div className="my-1 col-12">
          <InputField
            name={ServiceField.VERSION}
            label="Checker version"
            tooltip={mspVersionField?.title || ""}
            required={false}
            helpText="Specify a numeric version such as 1 or 2, or leave blank to upgrade to the latest version."
            placeholder="latest version"
          />
        </div>
      </form>
    </FormProvider>
  );
};
